(() => {
  const API_REVISION = '2026-07-15';
  const CUSTOM_SOURCE = 'Sensitive Skincare Society signup';

  const setMessage = (messageElement, message, type) => {
    messageElement.hidden = false;
    messageElement.textContent = message;
    messageElement.classList.toggle('sss-form-message--success', type === 'success');
    messageElement.classList.toggle('sss-form-message--error', type === 'error');
    messageElement.setAttribute('role', type === 'error' ? 'alert' : 'status');
  };

  const initializeForm = (form) => {
    if (form.dataset.sssNewsletterInitialized === 'true') return;

    const emailInput = form.querySelector('input[type="email"]');
    const submitButton = form.querySelector('[data-sss-newsletter-submit]');
    const submitLabel = form.querySelector('[data-sss-newsletter-submit-label]');
    const messageElement = form.querySelector('[data-sss-newsletter-message]');
    const fieldsElement = form.querySelector('[data-sss-newsletter-fields]');
    const companyId = form.dataset.klaviyoCompanyId;
    const listId = form.dataset.klaviyoListId;

    if (!emailInput || !submitButton || !submitLabel || !messageElement || !fieldsElement || !companyId || !listId) return;

    form.dataset.sssNewsletterInitialized = 'true';
    const defaultLabel = submitLabel.textContent;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!form.reportValidity()) return;

      const email = emailInput.value.trim();
      const loadingLabel = form.dataset.loadingLabel || defaultLabel;
      const successMessage = form.dataset.successMessage || 'Thank you for joining. Check your inbox for the next step.';
      const errorMessage = form.dataset.errorMessage || "We couldn't complete your signup. Please try again.";

      form.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      submitLabel.textContent = loadingLabel;
      messageElement.hidden = true;
      messageElement.textContent = '';
      emailInput.removeAttribute('aria-invalid');

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: API_REVISION,
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: CUSTOM_SOURCE,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED',
                          },
                        },
                      },
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId,
                  },
                },
              },
            },
          }),
        });

        if (!response.ok) throw new Error(`Klaviyo subscription request failed with status ${response.status}`);

        form.dataset.state = 'success';
        fieldsElement.hidden = true;
        emailInput.value = '';
        setMessage(messageElement, successMessage, 'success');
        messageElement.focus();
      } catch (error) {
        form.dataset.state = 'error';
        emailInput.setAttribute('aria-invalid', 'true');
        setMessage(messageElement, errorMessage, 'error');
        messageElement.focus();
        console.error('Sensitive Skincare Society signup failed.', error);
      } finally {
        form.removeAttribute('aria-busy');
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
        submitLabel.textContent = defaultLabel;
      }
    });
  };

  const initialize = () => {
    document.querySelectorAll('[data-sss-newsletter-form]').forEach(initializeForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
